export enum MapsViews {
    'Dashboard' = 'dashboard',
    'Plans' = 'plans',
    'Assort' = 'assort',
    'Reports' = 'reports'
}
